import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/common/auth'
import Template from '@/template/index'
import Authorized from '@/views/authorized'
import TesteRealizar from '@/views/testerealizar'
import AcessoNegado from '@/views/acessonegado'
import routersgenerated from './generated'

Vue.use(Router)


let childrens = routersgenerated.concat([
]);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/authorized',
            name: 'authorized',
            component: Authorized,
        },
        {
            path: '/acessonegado',
            name: 'acessonegado',
            component: AcessoNegado,
        },
        {
            path: '/teste-realizar/:candidatoId/:testeId',
            name: 'testerealizar',
            component: TesteRealizar,
        },
        {
            path: '/teste-realizar/:candidatoId/:testeId/:cpf',
            name: 'testerealizarcpf',
            component: TesteRealizar,
        },
        {
            path: '/',
            redirect: '/teste-realizar',
            component: Template,
            meta: { requiresAuth: true },
            children: childrens
        },

    ]
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!Auth.logged()) {
            Auth.login(true);
            return;
        }

        if (!Auth.canAccess(to.path)) {
            next('/acessonegado')
            return;
        }
    }
    next();
});


export default router;
